import { cloneDeep, merge } from 'lodash';
import { Injectable } from '@angular/core';

declare const $;

export interface ToastMessageConfig {
  description?: string;
  id?: number;
  ttl?: number;
  type?: ToastMessageType;
  icon?: string;
}

export const ToastIcon = {
  info: 'info',
  info_active: 'info',
  error: 'cancel',
  success: 'check_circle',
  warning: 'warning',
};

export type ToastMessageType = 'info' | 'info_active' | 'error' | 'success' | 'warning';

const defaultDataStructure: Required<ToastMessageConfig> = {
  description: '',
  id: 0,
  ttl: 5000,
  type: 'info',
  icon: ToastIcon['type'],
};

let id = 0;
export const timeouts = {};

//adjus time according to message length
const adjustTimeout = (message: string): number => {
  let time = message.length / 60;
  if (time < 1) {
    time = 1;
  } else if (time > 3) {
    //min. time 3 seconds;
    time = 3;
  } //max time 9 seconds;

  return 3000 * time;
};

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  public data: ToastMessageConfig[] = [];

  public show(message: string, type): number {
    let data: ToastMessageConfig = {
      description: message,
      type,
      ttl: adjustTimeout(message),
      icon: ToastIcon[type],
    };
    data.id = ++id;
    data = merge(cloneDeep(defaultDataStructure), data);
    this.data.push(data);

    if (data.ttl) {
      timeouts[id] = setTimeout(() => {
        if (data.ttl !== 0) {
          this.remove(data.id);
        }
      }, data.ttl);
    }
    return data.id;
  }

  public error(message: string): number {
    return this.show(message, 'error');
  }

  public success(message: string): number {
    return this.show(message, 'success');
  }
  public infoActive(message: string): number {
    return this.show(message, 'info_active');
  }
  public info(message: string): number {
    return this.show(message, 'info');
  }
  public warn(message: string): number {
    return this.show(message, 'warning');
  }

  public clearTimeout = (toastId: number) => {
    clearTimeout(timeouts[toastId]);
  };

  public getToastIndexById = (toastId: number) => this.data.findIndex((item) => item.id === toastId);

  public remove = (toastId: number) => {
    $('#toast-' + toastId).slideUp(100, () => {
      const index = this.getToastIndexById(toastId);
      this.data.splice(index, 1);
      this.clearTimeout(toastId);
    });
  };
}
